import { Flex, Skeleton } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import sharedStyles from '@jane/bloom/components/communicationBanner/shared.module.css';

import styles from './carouselSkeleton.module.css';

export function CarouselSkeleton({
  mode,
}: {
  mode: 'carousel' | 'image-banner';
}) {
  return (
    <div className={clsx(sharedStyles['bannerMargins'], styles['container'])}>
      <Flex flexDirection="column" width="100%" justifyContent="center">
        <Skeleton.Bone
          className={
            mode === 'carousel'
              ? styles['carouselSkeleton']
              : styles['imageBannerSkeleton']
          }
          width="100%"
        />
      </Flex>
    </div>
  );
}
